export default __webpack_public_path__ + "static/media/standard.05219655.jpg";